/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_TitleInputs */

const en_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three moves from prompt to final with Ideogram 4.5`)
};

const zh_landing_how_title = /** @type {(inputs: Landing_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 Ideogram 4.5 从提示词到定稿，只需三步`)
};

/**
* | output |
* | --- |
* | "Three moves from prompt to final with Ideogram 4.5" |
*
* @param {Landing_How_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_how_title = /** @type {((inputs?: Landing_How_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_how_title(inputs)
	return zh_landing_how_title(inputs)
});
export { landing_how_title as "landing.how.title" }